/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React, { useContext } from "react";
import { graphql, Link } from "gatsby";
import Img from "gatsby-image";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";
import Button from "~components/Button";
import Footer from "~components/Footer";
import Flipbook from "~components/Flipbook";
import Layout from "~components/Layout";
import Newsletter from "~components/Newsletter";
import Parallaxer from "~components/Parallaxer";
import SEO from "~components/SEO";
import WavySection from "~components/WavySection";
import { splitStringToParagraphs } from "~utils/helpers";

const IndexPage = ({ data, location }) => {
  const { setSubscriptionOverride } = useContext(AppContext);
  const { device } = useContext(DocumentContext);

  const { frontmatter } = data.markdownRemark;

  //

  return (
    <>
      <SEO
        customTitle={frontmatter.title}
        customDescription={frontmatter.seoDescription}
        customKeywords={frontmatter.seoKeywords}
        path={location.pathname}
      />

      <Layout className="index-page w-full relative pt-16 sm:pt-24 overflow-x-hidden bg-dark-green text-light-green">
        <section className="h-full grid items-center justify-center pb-v4">
          <div className="index-page__row index-page__row--0 animation-appear-slow animation-delay-3 grid-end-12 relative flex items-center">
            <span className="mr-v5 g1">A</span>
            <span className="g1">place</span>

            <div className="index-page__row__image h-full absolute top-0 right-0 flex items-center justify-center">
              <div className="animation-pop-slow animation-delay-3 w-full relative block">
                <figure style={{ width: `125%`, marginLeft: `-12.5%` }}>
                  {(device && device === `desktop` && (
                    <Flipbook image="croissant" initialDelay={250} />
                  )) || (
                    <img
                      className="w-full relative block"
                      src="/images/animation-croissant/croissant-1.svg"
                      alt="Person riding a croissant"
                    />
                  )}
                </figure>
              </div>
            </div>
          </div>

          <div className="index-page__row index-page__row--1 animation-appear-slow animation-delay-4 grid-end-12 relative flex items-center justify-between">
            <span className="g1">of </span>

            <div className="index-page__row__image h-full absolute transform-center flex items-center justify-center">
              <div className="animation-pop-slow animation-delay-3 w-full relative block">
                <figure style={{ width: `160%`, marginLeft: `-30%` }}>
                  {(device && device === `desktop` && (
                    <Flipbook
                      actionFrameLength={10}
                      image="moth"
                      initialDelay={500}
                    />
                  )) || (
                    <img
                      className="w-full relative block"
                      src="/images/animation-moth/moth-1.svg"
                      alt="Moth on a branch"
                    />
                  )}
                </figure>
              </div>
            </div>

            <span className="g1"> little</span>
          </div>

          <div className="index-page__row index-page__row--2 animation-appear-slow animation-delay-5 grid-end-12 relative flex items-center justify-end">
            <div className="index-page__row__image h-full absolute left-0 flex items-center justify-center">
              <div className="animation-pop-slow animation-delay-3 w-full relative block">
                <figure style={{ width: `250%`, marginLeft: `-75%` }}>
                  {(device && device === `desktop` && (
                    <Flipbook image="mushroom" initialDelay={750} />
                  )) || (
                    <img
                      className="w-full relative block"
                      src="/images/animation-mushroom/mushroom-1.svg"
                      alt="Hand holding a mushroom"
                    />
                  )}
                </figure>
              </div>
            </div>

            <span className="g1"> wonders</span>
          </div>
        </section>

        <section className="w-full relative z-10 bg-dark-green">
          <Img
            className="w-full relative block"
            fluid={frontmatter.introBanner.childImageSharp.fluid}
            alt="Pastries in a box"
          />

          <div className="desktop-only w-full absolute left-0 bottom-0 right-0 z-10">
            <div className="grid">
              <div className="grid-end-12 flex justify-end">
                <Link to="/products">
                  <Button className="mb-32 pt-5 px-16 pb-5" color="orange">
                    <span className="f-button">Visit the store</span>
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full relative pt-10 md:pt-24 pb-32 lg:pb-48 bg-light-green text-dark-green">
          <article className="grid text-center">
            <h2 className="grid-end-12 md:grid-end-8 md:grid-start-3 mb-4 md:mb-12 f1">
              {frontmatter.introTitle}
            </h2>

            {splitStringToParagraphs(
              frontmatter.intro,
              `grid-end-12 md:grid-end-8 md:grid-start-3 mt-4 f5`
            )}
          </article>
        </section>

        <div className="w-full relative">
          <Parallaxer className="w-full absolute top-0 right-0 z-20 -mt-24 md:-mt-32 md:mr-8">
            <div className="grid">
              <figure className="grid-end-6 sm:grid-end-4 grid-start-7 sm:grid-start-9 relative">
                {frontmatter?.introIllustration?.publicURL && (
                  <img
                    className="w-full relative block pr-2 md:pr-0 md:pl-v6"
                    src={frontmatter.introIllustration.publicURL}
                    alt="Pixies"
                  />
                )}
              </figure>
            </div>
          </Parallaxer>

          {frontmatter?.wavySections?.[0] &&
            frontmatter.wavySections.map((section, sectionIndex) => {
              const key = `section-${sectionIndex}`;

              let { color } = section;

              if (color === `white`) {
                color = `bone`;
              }

              //

              return (
                <div key={key}>
                  <WavySection color={section.backgroundColor}>
                    <div
                      className={`grid-end-12 sm:grid-end-6 ${
                        device === `mobile` || section?.imageAlign === `left`
                          ? ``
                          : `order-1`
                      }`}
                    >
                      <figure className="w-full h-full relative flex items-center justify-center">
                        {section?.image?.childImageSharp?.fluid && (
                          <Img
                            className="w-full h-full object-cover"
                            fluid={section.image.childImageSharp.fluid}
                            alt={section.image.imageAlt}
                          />
                        )}
                      </figure>
                    </div>

                    <article
                      className={`grid-end-12 sm:grid-end-6 md:px-12 flex flex-col items-center justify-center text-${color}`}
                    >
                      <h2 className="mt-8 md:mt-0 mb-4 md:mb-12 px-4 f2 text-center">
                        {section.heading}
                      </h2>

                      {splitStringToParagraphs(
                        section.content,
                        `mb-4 px-4 ${
                          device && device === `mobile` ? `b1` : `f5`
                        } text-center`
                      )}

                      <Link
                        to={section.buttonTarget}
                        className="w-full relative block"
                        onClick={() => {
                          if (section.buttonTarget.includes(`subscri`)) {
                            setSubscriptionOverride(true);
                          }
                        }}
                      >
                        <Button
                          className="w-full relative block mt-8 md:mt-12 pt-5 pb-5"
                          color={
                            section.backgroundColor === `dark-green`
                              ? `orange`
                              : `dark-green`
                          }
                        >
                          <span className="f-button">{section.buttonText}</span>
                        </Button>
                      </Link>
                    </article>
                  </WavySection>
                </div>
              );
            })}
        </div>

        <Newsletter />

        <Footer />
      </Layout>
    </>
  );
};

export default IndexPage;

//

export const query = graphql`
  query IndexPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        introBanner {
          childImageSharp {
            fluid(maxWidth: 2256, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
          publicURL
        }
        introTitle
        intro
        introIllustration {
          childImageSharp {
            fluid(maxWidth: 512, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
          publicURL
        }
        wavySections {
          heading
          content
          buttonText
          buttonTarget
          image {
            childImageSharp {
              fluid(maxWidth: 1280, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
            publicURL
          }
          imageAlt
          imageAlign
          backgroundColor
          color
        }
        productImage {
          childImageSharp {
            fluid(maxWidth: 1024, quality: 75) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
          publicURL
        }
        seoDescription
        seoKeywords
      }
    }
  }
`;
